import React, { useState, useEffect, useRef } from 'react';

import './select.scss';

import { Icon, Tag } from 'selfly-ui-react';

import useClickedOutside from './../../hooks/useClickedOutside';

export default function Select(props) {
    const [modalOpen, setModalStatus] = useState(false);

    const [selectedValue, setSelectedValue] = useState(() => {
        if (props.value === undefined) {
            return props.multiselect === true ? [] : null;
        }
        return props.value;
    });
    const modalEl = useRef(null);

    useClickedOutside(modalEl, e => {
        setModalStatus(false);
    });

    // Update selection when the provided value changes
    useEffect(() => {
        if (Array.isArray(props.options) && typeof props.value === 'object' && props.value !== null) {
            if (!props.multiselect) {
                const valueObject = props.options.find(op => op.value === props.value.value);
                if (valueObject !== undefined) {
                    setSelectedValue(oldValue => {
                        if (oldValue.value !== props.value.value) {
                            return props.value;
                        }
                        return oldValue;
                    });
                }
            } else {
                if (Array.isArray(props.value)) {
                    setSelectedValue(props.value);
                }
            }
        }
    }, [props.value, props.options, props.multiselect]);

    useEffect(() => {
        if (typeof props.onChange === 'function') {
            props.onChange(selectedValue);
        }
    }, [selectedValue]);

    function changeValue(newValue) {
        if (props.multiselect) {
            if (selectedValue.find(v => v.value === newValue.value) === undefined) {
                setSelectedValue(prev => {
                    const newList = [...prev];
                    newList.push(newValue);
                    return newList;
                });
            }
        } else {
            setSelectedValue(newValue);
        }
        setModalStatus(false);
    }

    function removeMultiSelectValue(value) {
        setSelectedValue(prev => {
            return prev.filter(item => {
                return item.value !== value.value;
            });
        });
    }

    function toggleModal(e) {
        setModalStatus(prev => {
            return !prev;
        });
    }

    const classes = ['custom-select'];
    if (props.className) {
        classes.push(props.className);
    }

    const textClasses = ['se-input', modalOpen ? 'se-input modal-open' : 'se-input modal-closed', props.multiselect === true ? 'multi-select' : ''];
    if ((props.multiselect !== true && selectedValue === null) || (props.multiselect === true && selectedValue.length === 0)) {
        textClasses.push('placeholder-text');
    }

    const modalClasses = [
        'custom-select-modal',
        props.openUp ? 'open-up' : '',
        props.openLeft ? 'open-left' : '',
        props.openRight ? 'open-right' : '',
        props.openCenter ? 'open-center' : '',
    ].join(' ');

    const labelText =
        props.multiselect === true
            ? null
            : selectedValue !== null
            ? selectedValue.label
            : typeof props.placeholder === 'string'
            ? props.placeholder
            : 'No selection...';
    return (
        <div className={classes.join(' ')} ref={modalEl}>
            <div className={textClasses.join(' ')} onClick={toggleModal}>
                {props.multiselect !== true && <p>{labelText}</p>}
                {props.multiselect === true && selectedValue.length > 0 && (
                    <div className="selections">
                        {selectedValue.map(val => (
                            <Tag
                                key={val.value}
                                onClose={e => {
                                    removeMultiSelectValue(val);
                                    e.stopPropagation();
                                }}>
                                {val.label}
                            </Tag>
                        ))}
                    </div>
                )}
                {props.multiselect === true && selectedValue.length === 0 && <p>{props.placeholder || 'No selection yet...'}</p>}
                {modalOpen ? <Icon>keyboard_arrow_up</Icon> : <Icon>keyboard_arrow_down</Icon>}
            </div>

            {modalOpen && (
                <div className={modalClasses}>
                    <div className="modal-content">
                        {Array.isArray(props.options) &&
                            props.options.map(opt => {
                                if (props.multiselectx !== true && selectedValue !== null && opt.value === selectedValue.value) {
                                    return (
                                        <div className="option selected" key={opt.value}>
                                            {opt.label}
                                        </div>
                                    );
                                }

                                if (props.multiselect === true && selectedValue.find(v => v.value === opt.value) !== undefined) {
                                    return (
                                        <div className="option multi-selected" key={opt.value} onClick={() => removeMultiSelectValue(opt)}>
                                            {opt.label} <Icon>close</Icon>
                                        </div>
                                    );
                                }

                                return (
                                    <div className="option" key={opt.value} onClick={() => changeValue(opt)}>
                                        {opt.label}
                                    </div>
                                );
                            })}
                    </div>
                </div>
            )}
        </div>
    );
}
